import Layout from 'components/Layout'
import MintComponent from 'components/mint/mintComponent'
import { ethers } from 'ethers'
import React, { useContext, useEffect, useState } from 'react'
import { useSignMessage } from 'wagmi'
import { blockchainData } from 'constants/DragonsHolder'
import BridgeComponent from 'components/bridge/bridgeComponent'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import Hero_5 from 'components/hero/hero_5'
import DragonBreed from 'components/DragonBreed'
import { ThirdwebSDK } from '@thirdweb-dev/sdk/evm'
import { ToastContext } from '../../context/ToastContextProvider'
import { ChainContext } from 'context/ChainContextProvider'
import { useEthersSigner } from 'utils/ethers'

const Index = () => {
  const {
    data,
    isError: isSignedError,
    isLoading: isSignedLoading,
    isSuccess,
    signMessage,
  } = useSignMessage({
    message: 'S1gnedV2Message!@DiJT',
  })

  const [hash, setHash] = useState<string>()
  const [selectedDragon1, setselectedDragon1] = useState<string | undefined>()
  const [selectedDragon2, setselectedDragon2] = useState<string | undefined>()
  const [selectedDragon1ID, setselectedDragon1ID] = useState<
    number | undefined
  >()
  const [selectedDragon2ID, setselectedDragon2ID] = useState<
    number | undefined
  >()

  const [isMinting, setMinting] = useState<boolean>(false)
  const [itemActive, setItemActive] = useState(1)
  const signer = useEthersSigner()
  const { chain } = useContext(ChainContext)

  const { addToast } = useContext(ToastContext)
  const [sdk, setSDK] = useState<ThirdwebSDK>()
  const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

  const BREEDING_ENABLED: boolean = isProduction ? false : true // False on production and true on development
  const STAKING_ENABLED: boolean = isProduction ? false : true // False on production and true on development
  const BRIDGING_ENABLED: boolean = isProduction ? false : true // False on production and true on development

  const tabItem = [
    {
      id: 1,
      text: 'Mint',
      icon: 'on-sale',
    },
    {
      id: 2,
      text: 'Breed',
      icon: 'hert-fill',
    },
    {
      id: 3,
      text: 'Stake',
      icon: 'list',
    },
    {
      id: 4,
      text: 'Bridge',
      icon: 'transfer',
    },
  ]
  useEffect(() => {
    if (signer) {
      const temp = ThirdwebSDK.fromSigner(signer)
      setSDK(temp)
    }
  }, [signer])
  const getHash = () => {
    const message = 'S1gnedV2Message!@DiJT'
    const messageHash = ethers.utils.hashMessage(message)
    setHash(messageHash)
  }
  let notifyError = (message: string) =>
    addToast?.({
      title: 'Error',
      description: message,
      status: 'error',
    })

  let notifySuccess = (message: string) =>
    addToast?.({
      title: 'Success',
      description: message,
      status: 'success',
    })
  const breedDragon = async () => {
    setMinting(true)
    sdk!.updateSignerOrProvider(signer!)
    const contractAddress = getCollectionAddress(chain.name)
    const contract = await sdk!.getContract(contractAddress!)
    if (selectedDragon1ID) {
      if (selectedDragon2ID) {
        try {
          const data = await contract.call('Breed', [
            selectedDragon1ID,
            selectedDragon2ID,
          ])
          setMinting(false)
          notifySuccess('Breeding Success!')
        } catch (error) {
          if (error instanceof Error) {
            //alert(error.message.toString());
            const err = JSON.parse(error.message.split('| Raw error |')[1])
            //alert(err.reason.split(": ")[1]);
            notifyError(err.reason.split(': ')[1])
            setMinting(false)
          }
        }
      } else {
        notifyError('Dragon 2 is empty!')
        setMinting(false)
      }
    } else {
      notifyError('Dragon 1 is empty!')
      setMinting(false)
    }
  }
  function getCollectionAddress(chainName: string): string {
    if (chainName.toLowerCase() == 'polygon mumbai') {
      chainName = 'mumbai'
    }
    if (chainName.toLowerCase() == 'binance smart chain testnet') {
      chainName = 'bsc-testnet'
    }
    const sepoliaData = blockchainData.find(
      (data) => data.chain === chainName.toLocaleLowerCase()
    )
    return sepoliaData?.collectionAddress!
  }
  return (
    <>
      <Layout>
        <Hero_5 />
        <div className="flex items-center justify-center flex-col max-w-[90%] mx-auto pb-4">
          <Tabs className="tabs min-w-full">
            <TabList className="nav nav-tabs scrollbar-custom mb-12 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-100 pb-px dark:border-jacarta-600 md:justify-center">
              {tabItem.map(({ id, text, icon }) => {
                return (
                  <Tab
                    className="nav-item"
                    role="presentation"
                    key={id}
                    onClick={() => setItemActive(id)}
                  >
                    <button
                      className={
                        itemActive === id
                          ? 'nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white active'
                          : 'nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white'
                      }
                    >
                      <svg className="icon mr-1 h-5 w-5 fill-current">
                        <use xlinkHref={`/icons.svg#icon-${icon}`}></use>
                      </svg>
                      <span className="font-display text-base font-medium">
                        {text}
                      </span>
                    </button>
                  </Tab>
                )
              })}
            </TabList>
            <TabPanel>
              <div>
                <div className="flex flex-col space-x-0 space-y-2 lg:flex-row lg:space-x-2 lg:space-y-0 justify-center min-h-[400px]">
                  {blockchainData.map((data, index) => (
                    <div key={index}>
                      <MintComponent
                        contractAddress={data.collectionAddress}
                        chain={data.chain}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="mt-6">
                {BREEDING_ENABLED ? (
                  <div className="w-100 justify-center min-h-[400px]">
                    <div className="flex flex-row flex-wrap w-100 justify-center gap-4 mx-2">
                      <div className="inline-flex flex-col items-center xs:w-[45%] lg:w-[30%]">
                        <img
                          className="cursor-pointer rounded-2xl"
                          src={selectedDragon1 || '/egg3.png'}
                          alt="Dragon1"
                          onClick={() => {
                            setselectedDragon1(undefined)
                          }}
                        />
                        <span>
                          {selectedDragon1ID ? selectedDragon1ID : ''}
                        </span>
                      </div>
                      <div className="inline-flex flex-col items-center xs:w-[45%] lg:w-[30%]">
                        <img
                          className="cursor-pointer rounded-2xl"
                          src={selectedDragon2 || '/egg3.png'}
                          alt="Dragon2"
                          onClick={() => {
                            setselectedDragon2(undefined)
                          }}
                        />
                        <span>
                          {selectedDragon2ID ? selectedDragon2ID : ''}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-row justify-center mt-[24px]">
                      {!isMinting ? (
                        <button
                          className=" rounded-2xl bg-accent w-[150px] h-[50px] text-lg"
                          onClick={breedDragon}
                        >
                          Breed
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="flex items-center rounded-2xl bg-accent w-[150px] h-[50px] text-lg opacity-50 cursor-not-allowed"
                        >
                          <svg
                            className="animate-spin ml-2 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Breeding...
                        </button>
                      )}
                    </div>
                    <DragonBreed
                      setToken1Image={setselectedDragon1}
                      setToken2Image={setselectedDragon2}
                      setTokenId={setselectedDragon1ID}
                      setTokenId2={setselectedDragon2ID}
                      token1Image={selectedDragon1}
                      token2Image={selectedDragon2}
                      selectedToken={selectedDragon1ID}
                      selectedToken2={selectedDragon2ID}
                    />
                  </div>
                ) : (
                  <div className="min-w-full text-center text-xl min-h-[400px]">
                    Breeding coming soon
                  </div>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              {STAKING_ENABLED ? (
                <div className="min-w-full text-center text-xl min-h-[400px]">
                  Staking coming soon
                </div>
              ) : (
                <div className="min-w-full text-center text-xl min-h-[400px]">
                  Staking coming soon
                </div>
              )}
            </TabPanel>
            <TabPanel>
              {BRIDGING_ENABLED ? (
                <div className="min-h-[400px]">
                  <BridgeComponent />
                </div>
              ) : (
                <div className="min-w-full text-center text-xl min-h-[400px]">
                  Bridging coming soon
                </div>
              )}
            </TabPanel>
          </Tabs>

          {/*<button
            className="bg-primary h-10 w-20 mt-4 rounded-lg"
            disabled={isLoading}
            onClick={() => {
              signMessage()
              getHash()
            }}
          >
            Sign
          </button>
          {isSuccess && <div>Signature: {data}</div>}
          {isError && <div>Error signing message</div>}
          {hash && <div>Hash: {hash}</div>}*/}
        </div>
        
      </Layout>
    </>
  )
}

export default Index
